import { HttpClient } from '../HttpClient';
/**
 * * Get List of Reports
 */

export const GetReportsList = async ({ PageNumber, RowsPerPage, ReportType, SortOrder = 'desc' }) => {
  try {
    const { data } = await HttpClient.get('api/reports', {
      params: {
        PageNumber,
        RowsPerPage,
        Type: ReportType,
        SortOrder,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
